import { useDispatch } from 'react-redux';
import {
  TRefreshDocumentsParams,
  TUseCovenantsApplicationRefreshParams,
} from '~/modules/covenants/types.ts';
import { AppDispatch } from '~/store/store.ts';
import {
  fetchApplication,
  fetchApplicationDocuments,
} from '~/store/covenants/thunks/applicationThunks.ts';

export const useCovenantsApplicationRefresh = ({
  applicationId,
  application,
  contragentId,
  documentsPage,
  documentsRowsPerPage,
}: TUseCovenantsApplicationRefreshParams) => {
  const dispatch = useDispatch<AppDispatch>();

  const refreshDocumentList = async (params?: Partial<TRefreshDocumentsParams>) => {
    const nextApplicationId = params?.applicationId ?? application?.id;
    const nextStatus = params?.status ?? application?.status;

    if (!nextApplicationId || !nextStatus || !contragentId) {
      return;
    }

    try {
      await dispatch(
        fetchApplicationDocuments({
          contragentId,
          applicationId: nextApplicationId,
          status: nextStatus,
          page: documentsPage,
          size: documentsRowsPerPage,
        })
      ).unwrap();
    } catch {
      return;
    }

  };

  const refreshApplicationData = async () => {
    if (!applicationId || !contragentId) {
      return;
    }

    const refreshedApplication = await dispatch(
      fetchApplication({
        contragentId,
        applicationId,
      })
    ).unwrap();

    await refreshDocumentList({
      applicationId: refreshedApplication.id,
      status: refreshedApplication.status,
    });
  };

  return {
    refreshApplicationData,
    refreshDocumentList,
  };
};
